﻿<script>
  export let className;
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  width="26"
  height="26"
  viewBox="0 0 26 26"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
  class={className}>
  <g transform="translate(1.000000, 1.000000)">
    <path
      d="M0.5,11.9999998 C0.5,16.1085543 2.69188754,19.9050151
      6.24999995,21.9592923 C9.80811236,24.0135695 14.1918876,24.0135695
      17.75,21.9592923 C21.3081125,19.9050151 23.5,16.1085543 23.5,11.9999998
      C23.5,7.89144568 21.3081125,4.09498489 17.75,2.04070771
      C14.1918876,-0.0135694664 9.80811236,-0.0135694664 6.24999995,2.04070771
      C2.69188754,4.09498489 0.5,7.89144568 0.5,11.9999998 L0.5,11.9999998 Z"
      id="Path" />
    <line x1="7" y1="7" x2="17" y2="17" id="Path" />
    <line x1="17" y1="7" x2="7" y2="17" id="Path" />
  </g>
</svg>
